import React from 'react';
import { connect } from 'react-redux';
import { AppState } from '$/store';
import TranscriptsGrid from '$/components/transcripts-grid';
import * as Bixby from '$/core';
import { getIsCurrentCompanyPublicState } from '$/store/company/selectors';
import { getCreditSightsTranscriptionsIntegrationEnabled } from '$/store/release-feature-flags/selectors';
import { toastError, toastSuccess } from '$/store/toast/actions';

export interface ICompanyTranscriptProps {
  currentCompany?: Bixby.Models.AdminCompany;
  isCurrentCompanyPublic: boolean;
  isCreditSightsTranscriptionsIntegrationEnabled: boolean;
  dispatchToastError: (message: string) => Promise<void>;
  dispatchToastSuccess: (message: string) => Promise<void>;
}

const CompanyTranscripts: React.FC<ICompanyTranscriptProps> = props => {
  const {
    currentCompany,
    isCurrentCompanyPublic,
    isCreditSightsTranscriptionsIntegrationEnabled,
    dispatchToastError,
    dispatchToastSuccess,
  } = props;

  return currentCompany ? (
    <div className="admin-profile-section bottom">
      {isCurrentCompanyPublic ? (
        <p>Transcripts not available for public companies.</p>
      ) : (
        <TranscriptsGrid
          companyId={currentCompany.id}
          isCurrentCompanyMnpi={currentCompany.declarationType === Bixby.Enums.DeclarationType.Private}
          isCreditSightsTranscriptionsIntegrationEnabled={isCreditSightsTranscriptionsIntegrationEnabled}
          dispatchToastError={dispatchToastError}
          dispatchToastSuccess={dispatchToastSuccess}
        />
      )}
    </div>
  ) : null;
};

const mapStateToProps = (state: AppState) => {
  const { isCurrentCompanyPublic } = getIsCurrentCompanyPublicState(state);
  const { isCreditSightsTranscriptionsIntegrationEnabled } = getCreditSightsTranscriptionsIntegrationEnabled(state);

  return {
    isCurrentCompanyPublic,
    currentCompany: state.companyState.currentCompany,
    isCreditSightsTranscriptionsIntegrationEnabled,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  dispatchToastError: (message: string) => dispatch(toastError(message)),
  dispatchToastSuccess: (message: string) => dispatch(toastSuccess(message)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CompanyTranscripts);
